<script lang="ts">
import { appCode } from '../config';

export default {
  name: appCode,
};
</script>

<script setup lang="ts">
import { store, storeModuleTypes, environmentGetterTypes, vueExports } from 'vue-infra';
import { appName } from '../config';
import './styles/app.scss';

const { computed } = vueExports;
const theme = computed(() => {
  return store.getters[`${storeModuleTypes.ENVIRONMENT}/${environmentGetterTypes.CURRENT_ACTIVE_THEME}`];
});
</script>

<template>
  <div :id="appName" :class="[appCode, appName, theme]">
    <router-view :name="appCode" :key="$route.fullPath"></router-view>
    <div id="cmc-dialog-destination" class="dialog-portal"></div>
  </div>
</template>

<style scoped lang="scss">
.lp-le-custom-management-console {
  position: relative;
  height: 100%;
  font-family: $font-family-Roboto, Arial;
  line-height: 135%;
  @include themify {
    color: getColor('text');
  }
}
</style>
